import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const logo = css`
  width: ${3 * unit}px;
`
